module.exports = __webpack_public_path__ + "media/volvo/assets/images/instagram@2x-d3c1f9d438cd501d59d32205658dcffe.png";